import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getProfile } from '../../../../redux/modules/profile/selectors';
import TableCard from '../components/table-card';
import { getAssignedPrioritiesV2 } from '../../../../services/priority/priority.service';
import { mapToLegacy } from '../../../../utils/CommonUtils';
import { colors, fontWeight, Text, textLevel } from '../../../../packages';
import { Box } from '@mui/material';

const Diagnoses = ({
  memberId,
  onViewAll,
  hideNotes,
  title = '',
  reset,
  onClick,
  isCardView = false,
  setCount = () => {},
}) => {
  const typeName = 'diagnoses';
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const { lookupData } = useSelector(getProfile);

  useEffect(() => {
    setLoading(true);
    if (memberId) {
      getAssignedPrioritiesV2({
        patientId: memberId,
        dataDomainType: typeName,
        pageNumber: 0,
        pageSize: 500,
      })
        .then(({ data }) => {
          setRecords(data.records.map(record => mapToLegacy(record, lookupData)));
          setCount(prev => ({ ...prev, activeDiagnoses: data.totalRecords }));
          setLoading(false);
        })
        .catch(e => {
          console.error(e);
          setLoading(false);
          setRecords([]);
        });
    }
  }, [memberId, reset]);

  const columns = [
    {
      id: 'name',
      label: 'Diagnosis name',
    },
    {
      id: 'provider',
      label: 'Diagnosing provider',
    },
    {
      id: 'icd',
      label: 'ICD-10 Code',
    },
    {
      id: 'createdAt',
      label: 'Date added',
    },
    {
      id: 'status',
      label: 'Status',
    },
  ];

  if (!loading && records.length === 0) {
    return null;
  }
  return (
    <>
      {isCardView ? (
        <Box display="flex" flexDirection="column" gap="4px">
          <Text level={textLevel.M} weight={fontWeight.MEDIUM} color={colors.neutral900}>
            {records.map(record => record.icd).join(', ')}
          </Text>
          <Text level={textLevel.S} weight={fontWeight.MEDIUM} color={colors.neutral600}>
            {records.map(record => record.name).join(', ')}
          </Text>
        </Box>
      ) : (
        <TableCard
          columns={columns}
          data={records}
          loading={loading}
          title={title === '' ? 'Diagnoses' : title}
          hideNotes={hideNotes}
          onRowClick={item => onClick(item, typeName)}
          action={{ onClick: () => onViewAll(typeName), label: 'View all' }}
        />
      )}
    </>
  );
};

export default Diagnoses;
